import { createModule } from '@vue-storefront/core/lib/module'
import { afterRegistration } from './hooks/afterRegistration'

const KEY = 'attentive'

export const Attentive = createModule({
  key: KEY,
  afterRegistration
})
